import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  CalendarAvailableBlock,
  formatMinuteRange,
  minutesToPixels,
} from '../../../utils/schedule-calendar.utils';

/**
 * Read only available time from another schedule, such as the project's
 * interview period on an expert's availability, shown as a narrow bar down the
 * side of the day with its preferred ranges inside it
 */
@Component({
  selector: 'app-schedule-calendar-period-bar',
  templateUrl: './schedule-calendar-period-bar.component.html',
  styleUrls: ['./schedule-calendar-period-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTooltipModule],
  host: {
    '[style.top.px]': 'top()',
    '[style.height.px]': 'height()',
  },
})
export class ScheduleCalendarPeriodBarComponent {
  readonly block = input.required<CalendarAvailableBlock>();
  readonly availableLabel = input('Available');
  readonly preferredLabel = input('Preferred');

  readonly top = computed(() => minutesToPixels(this.block().start));
  readonly height = computed(() =>
    minutesToPixels(this.block().end - this.block().start)
  );

  readonly preferred = computed(() =>
    this.block().preferred.map((range) => ({
      top: minutesToPixels(range.start - this.block().start),
      height: minutesToPixels(range.end - range.start),
    }))
  );

  readonly tooltip = computed(() =>
    [
      [this.availableLabel(), formatMinuteRange(this.block())],
      ...this.block().preferred.map((range) => [
        this.preferredLabel(),
        formatMinuteRange(range),
      ]),
    ]
      .map((line) => line.join(' '))
      .join('\n')
  );
}
